import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { TenantProvider } from './context/TenantContext';
import { SettingsProvider } from './context/SettingsContext';
import { LanguageProvider } from './context/LanguageContext';
import { BrandingProvider } from './context/BrandingContext';

// Lazy-load App so Fast Refresh does not need to re-evaluate the full admin
// import tree when AppWrapper hot-reloads (avoids default-export TDZ errors).
const App = React.lazy(() => import('./App'));

const AppWrapper = () => {
  return (
    <BrowserRouter>
      <TenantProvider>
        <BrandingProvider>
          <LanguageProvider>
            <SettingsProvider>
              <Suspense fallback={null}>
                <App />
              </Suspense>
            </SettingsProvider>
          </LanguageProvider>
        </BrandingProvider>
      </TenantProvider>
    </BrowserRouter>
  );
};

export default AppWrapper;
